import { sound } from './audio/sound';
import { setHapticsEnabled } from './audio/haptics';

/**
 * Player options. Stored in this browser only; Phase 5 moves them into the
 * save game. Storage may be unavailable (private mode) – then defaults apply.
 */
export interface Settings {
  sound: boolean;
  haptics: boolean;
}

const KEY = 'cafe-paws.settings';
let current: Settings = { sound: true, haptics: true };

export function loadSettings(): Settings {
  try {
    current = { ...current, ...JSON.parse(localStorage.getItem(KEY) ?? '{}') };
  } catch {
    /* defaults */
  }
  apply();
  return current;
}

export function settings(): Settings {
  return current;
}

export function updateSettings(patch: Partial<Settings>): void {
  current = { ...current, ...patch };
  apply();
  try {
    localStorage.setItem(KEY, JSON.stringify(current));
  } catch {
    /* not persisted */
  }
}

function apply(): void {
  sound.muted = !current.sound;
  setHapticsEnabled(current.haptics);
}
